import type {
  AdsAccountLoadUrlLogItem,
  AdsAccountLoadUrlLogRequest,
  UpdateIndustryLabelParams,
} from './types'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'
import { DateRanges, formatDateRange } from '#/utils'

export const industryReportApi = defineApi('operation', ({ prefix }) => {
  function getAdsAccountLoadUrlLogParams(params: AdsAccountLoadUrlLogRequest) {
    const reportDate = formatDateRange(params.condition?.reportDate)

    return {
      customerId: params.condition?.customerId,
      accountId: params.condition?.accountId,
      adId: params.condition?.adId,
      industryC1Code: params.condition?.industryC1Code?.length
        ? params.condition.industryC1Code
        : undefined,
      industryC2Code: params.condition?.industryC2Code?.length
        ? params.condition.industryC2Code
        : undefined,
      loadUrl: params.condition?.loadUrl,
      reportDate: DateRanges.dates(
        DateRanges.fullWeek(reportDate?.length === 2 ? reportDate : undefined),
      ),
    }
  }

  /**
   * 查询行业报表，一级、二级标签按多选 code 数组传递。
   * POST /adsAccountLoadUrlLog/query
   */
  function getAdsAccountLoadUrlLog(params: AdsAccountLoadUrlLogRequest) {
    const requestParams = {
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
      sortBy: params.sortBy,
      orderBy: params.orderBy,
      condition: getAdsAccountLoadUrlLogParams(params),
    }
    return requestClient
      .post<{
        list?: AdsAccountLoadUrlLogItem[]
        total: number
      }>(prefix('adsAccountLoadUrlLog/query'), requestParams)
      .then((res) => ({ items: res.list ?? [], total: res.total }))
  }

  /**
   * 更新行业标签，industryLabel 同步所选最深一级中文名称。
   * POST /adsAccountLoadUrlLog/updateIndustryLabel
   */
  function updateIndustryLabel(params: UpdateIndustryLabelParams) {
    return requestClient.post<null>(
      prefix('adsAccountLoadUrlLog/updateIndustryLabel'),
      params,
    )
  }

  return {
    getAdsAccountLoadUrlLogParams,
    getAdsAccountLoadUrlLog,
    updateIndustryLabel,
  }
})
